// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SY1EtlmIWoeLd9JD2WvD,
.SY1EtlmIWoeLd9JD2WvD:focus,
.SY1EtlmIWoeLd9JD2WvD:active,
.SY1EtlmIWoeLd9JD2WvD:hover {
  display: flex !important;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 42px !important;
  border: none !important;
  border-radius: 12px !important;
  box-shadow: none !important;
}

.WM71V6jMqqTTKHsreir1 {
  right: 8px !important;
  transform: rotate(180deg) !important;
}

.pNx2bSIIpFrBcY6sMitK {
  margin-right: 9px;
}

.KBySybQA8O4RO0L_K8UN {
  margin-right: 0;
  margin-left: 0;
}`, "",{"version":3,"sources":["webpack://./js/view/component/sidebar-toggle/index.scss"],"names":[],"mappings":"AAAA;;;;EAIE,wBAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,uBAAA;EACA,uBAAA;EACA,8BAAA;EACA,2BAAA;AACF;;AAEA;EACE,qBAAA;EACA,oCAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;AACF","sourcesContent":[".toggle_button,\n.toggle_button:focus,\n.toggle_button:active,\n.toggle_button:hover {\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n  width: 42px;\n  height: 42px !important;\n  border: none !important;\n  border-radius: 12px !important;\n  box-shadow: none !important;\n}\n\n.close_icon {\n  right: 8px !important;\n  transform: rotate(180deg) !important;\n}\n\n.close_toggle_button {\n  margin-right: 9px;\n}\n\n.open_toggle_button {\n  margin-right: 0;\n  margin-left: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"toggle_button": `SY1EtlmIWoeLd9JD2WvD`,
	"close_icon": `WM71V6jMqqTTKHsreir1`,
	"close_toggle_button": `pNx2bSIIpFrBcY6sMitK`,
	"open_toggle_button": `KBySybQA8O4RO0L_K8UN`
};
export default ___CSS_LOADER_EXPORT___;
